module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('router-link', {
    staticClass: "icon iconfont icon-msg",
    attrs: {
      "to": "/chat"
    }
  })], 1), _vm._v(" "), _c('footer')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": "static/images/bot.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73b7c21c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mycard/mycard.vue
// module id = 430
// module chunks = 3